export default __webpack_public_path__ + "static/media/banner_va_3.c71edc27.jpg";